/****************************************************
 * Module Name:  addStoneTypeModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import StoneTypeProxy from "../../utility/proxy/manager/stoneTypeProxy";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, Checkbox, FormControlLabel, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddStoneTypeModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newstoneType: this.props.editOperation ? this.props.sourceData.name : "",
            newstoneTypefullname: this.props.editOperation
                ? this.props.sourceData.fullname
                : "",
            newhsCode: this.props.editOperation
                ? this.props.sourceData.hscode === null ? "" : this.props.sourceData.hscode
                : "",
            newdisabled: this.props.editOperation
                ? this.props.sourceData.disabled
                : "",
            newseq: this.props.editOperation ? this.props.sourceData.seq : "",

            showError: false,

            validateStoneTypePresentSpinner: false,
            showValidationMessage: false,
            stoneTypeAvailable: true,

            stoneTypeValidationError: "",
            fullNameValidationError: "",
            hsCodeValidationError: "",
        };
    }

    handleSave = () => {
        let data = {
            name: this.state.newstoneType,
            fullname: this.state.newstoneTypefullname,
            hscode: this.state.newhsCode,
            disabled: !this.state.newdisabled ? false : true,
            seq: this.state.newseq
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data))
                    this.props.handleSave(data);
                else
                    this.setState({ showError: true });
            } else
                this.props.handleSave(data);
        }
    };

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    validateStoneTypePresent = (stoneTypeEntered) => {
        if (!stoneTypeEntered || stoneTypeEntered.trim() === "") return;

        this.setState({
            validateStoneTypePresentSpinner: true,
        });

        StoneTypeProxy.CheckStoneTypeAvailable(stoneTypeEntered, (response) => {
            //if we got response that means stoneType is present at backend
            if (response) {
                //StoneTypeName already present
                this.setState({
                    validateStoneTypePresentSpinner: false,
                    showValidationMessage: true,
                    stoneTypeAvailable: false,
                });
            } else {
                //StoneTypeName not available, so can be used
                this.setState({
                    validateStoneTypePresentSpinner: false,
                    showValidationMessage: true,
                    stoneTypeAvailable: true,
                });
            }
        });
    };

    buttonDisable = () => {
        if (this.props.editOperation && this.state.newstoneTypefullname.length === 0)
            return true;

        if (this.props.editOperation && this.state.newhsCode.length === 0)
            return true;
        if (!this.props.editOperation)
            return (
                !this.state.showValidationMessage ||
                !this.state.stoneTypeAvailable ||
                this.state.newstoneTypefullname.length === 0 ||
                this.state.newhsCode.length === 0
            );

        return false;
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add stoneType validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />

                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            {this.props.editOperation ? "Edit StoneType" : "Add New StoneType"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                StoneType <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        {this.props.editOperation ? (
                                            <td>
                                                <Form.Label>{this.state.newstoneType}</Form.Label>
                                            </td>
                                        ) : (
                                            <td>
                                                <TextField
                                                    margin="normal"
                                                    fullWidth
                                                    size="small"
                                                    label="StoneType (required)"
                                                    placeholder="Enter StoneType"
                                                    value={this.state.newstoneType}
                                                    autoFocus
                                                    onBlur={(e) =>
                                                        this.validateStoneTypePresent(this.state.newstoneType)
                                                    }
                                                    onChange={(e) =>
                                                        this.setState({
                                                            newstoneType: e.target.value,
                                                            showValidationMessage: false,
                                                            stoneTypeValidationError: Utility.CheckIsPresent(
                                                                e.target.value
                                                            )
                                                                ? ""
                                                                : "StoneType Cannot be Empty",
                                                        })
                                                    }
                                                    helperText={this.state.stoneTypeValidationError}
                                                    error={this.state.stoneTypeValidationError.length > 0}
                                                />
                                            </td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>
                                            {this.state.validateStoneTypePresentSpinner ? (
                                                <CircularProgress size="1rem" />
                                            ) : !this.state.showValidationMessage ? (
                                                <Box>&nbsp;</Box>
                                            ) : this.state.stoneTypeAvailable ? (
                                                <font color="green">StoneType available</font>
                                            ) : (
                                                <font color="red">StoneType not available</font>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                StoneType Fullname <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="StoneType Fullname (required)"
                                                placeholder="Enter StoneType Fullname"
                                                value={this.state.newstoneTypefullname}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newstoneTypefullname: e.target.value,
                                                        fullNameValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "StoneType Fullname Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.fullNameValidationError}
                                                error={this.state.fullNameValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                HS Code<sup style={{ color: "red" }}></sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="HS Code (required)"
                                                placeholder="Enter HS Code"
                                                value={this.state.newhsCode}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newhsCode: e.target.value,
                                                        hsCodeValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "HS Code Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.hsCodeValidationError}
                                                error={this.state.hsCodeValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Sequence</Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Sequence"
                                                placeholder="Enter Sequence"
                                                value={this.state.newseq}
                                                onChange={(e) =>
                                                    this.setState({ newseq: e.target.value })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><Form.Label>Disabled</Form.Label></td>
                                        <td>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={this.state.newdisabled}
                                                        onChange={(e) =>
                                                            this.setState({
                                                                newdisabled: !this.state.newdisabled,
                                                            })
                                                        }
                                                    />
                                                }
                                                sx={{
                                                    "& .MuiFormControlLabel-label": {
                                                        fontSize: "0.8rem",
                                                    },
                                                }}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.buttonDisable()}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
}
